/**
 * The two brand names, in a module of their own — no drizzle, no zod, no imports at all.
 *
 * `BRAND` used to be declared in the package barrel (`index.ts`), which re-exports
 * `db/schema` — so a browser that wanted two strings pulled the whole of drizzle-orm in
 * behind them. web-billing's invoice page was doing exactly that.
 *
 * The barrel still re-exports this, so nothing that imports `BRAND` from
 * `@lodex-pro/shared` changes. New browser code should import
 * `@lodex-pro/shared/brand`.
 *
 * The split itself is the DEC-147 / master-spec rule and is not a detail: product UI says
 * `lodeX Pro`, while invoices, contracts, transactional email and internal admin say
 * `Paelode Systems`. Reach for `legal` only on those surfaces.
 */

export const BRAND = {
  product: 'lodeX Pro',
  legal: 'Paelode Systems',
} as const;

export type Brand = typeof BRAND;
